<template>
  <div class="userImport">
    <div class="content">
      <div class="header_operation">
        <el-button type="primary" size="small">新建批量导入</el-button>
        <el-button size="small">会员验证链接</el-button>
      </div>
      <div class="">
        <template>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="日期" width="180">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="address" label="地址">
            </el-table-column>
          </el-table>
        </template>
      </div>
      <div class="changePage">
        <span>共0条，每页10条</span>
        <el-button icon="el-icon-arrow-left" size="small"></el-button>
        <el-button icon="el-icon-arrow-right" size="small"></el-button>
        <span>跳至</span>
        <el-input v-model="input" size="small" ></el-input>
        <span>页</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userImport", // 用户导入
  data() {
    return {
      activeName: 'first',
      carData: [
        {
          color: "rgb(38, 159, 255)"
        },
        {
          color: "rgb(47, 174, 68)"
        }
      ],
      tableData: [
        
      ]
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.userImport {
  margin: 16px;
  background: #fff;
  min-height: 300px;
  .content {
    padding: 16px;
    .header_operation {
      margin-bottom: 10px;
    }
    .changePage {
      margin-top: 16px;
      text-align: right;
      span{
        margin: 0 10px;
      }
      .el-input {
        width: 40px;
      }
    }
  }
}
</style>

<style lang="scss">
.userImport {
  .el-table th, .el-table tr {
    background-color: #f2f2f2 !important;
  }
}
</style>
